<template>
    <div class="card-album">
        <ProjectCard 
            img = "thumbnails/bsc.gif"
            title = "Multiple Object Tracking"
            subTitle = "Trackig droplets in hydrodynamic quantum analog"
            description = "
                The SORT technique was modified and applied on a video of a hydrodynamic quantum analogue experiment. 
                The droplets are small whcih made tracking difficult.
            "
            programmingLanguage = "Python"
            :technologies = "['PyTorch','OpenCV','scikit-learn','numpy','Matplotlib']"
            :buttons = "[{'text':'View Poster', 'link':'resources/bsc/bsc_poster.pdf', isLocalPage:false},
            {'text':'git', 'link':'https://github.com/TJ-coding/droplet_tracker', isLocalPage:false}]"
            month = "March"
            year = "2021"
        />
        <ProjectCard 
            img = "thumbnails/sepnet20.jpg"
            title = "NER Using Bidirectional-LSTM"
            subTitle = "SEPnet 6 Best Posters Prize Winner"
            description = "
               The NER model was trained with auto labelled training data. An interesting 'trick' was applied that allowed the model to perform better than the training data.
            "
            programmingLanguage = "Python, C#"
            :technologies = "['TensorFlow .keras','scikit-learn','Service fabric Actor model',]"
            :buttons = "[{'text':'View Poster', 'link':'resources/sepnet20/poster.pdf', isLocalPage:false},
            {'text':'MeVitae', 'link':'https://www.mevitae.com', isLocalPage:false},
            {'text':'SEPnet', 'link':'https://www.sepnet.ac.uk/2020/11/', isLocalPage:false}]"
            month = "June"
            year = "2020"
        />
        <ProjectCard 
            img = "thumbnails/quadTree.gif"
            title = "Winning a Hackathon"
            subTitle = "Quadtree web compression"
            description = "
                I participated in the Royal Hackaway, a hackathon at my university.
                Our team was awarded the grand prize and the (MLH) Best use of Google Cloud. 

            "
            programmingLanguage = "Go"
            :technologies = "['git', 'Google cloud compute']"
            :buttons = "[{'text':'DevPost', 'link':'https://devpost.com/software/quadtree-web-compression', isLocalPage:false},
            {'text':'git', 'link':'https://github.com/TJ-coding/quadtree', isLocalPage:false}]"
            month = "February"
            year = "2020"
        />
        <ProjectCard 
            img = "thumbnails/sepnet19.jpg"
            title = "Document Vectorization"
            subTitle = "MeVitae: Algorithm Developer Intern"
            description = "
                Developed a program that convert job descriptions into vectors using latent semantic analysis. Successfully implemented a concurrent implementation of tf-idf.
            "
            programmingLanguage = "Python, C#, Go"
            :technologies = "['NLTK', 'GloVe', 'Word2vec', 'scikit-learn', 'Goroutines']"
            :buttons = "[{'text':'View Poster', 'link':'resources/sepnet19/poster.pdf', isLocalPage:false},
            {'text':'MeVitae', 'link':'https://www.mevitae.com', isLocalPage:false},
            {'text':'University', 'link':'https://www.royalholloway.ac.uk/research-and-teaching/departments-and-schools/physics/your-future-career/placements/2019-successful-summer-placements-pages/2019-jinno-tomoyuki-mevitae/', isLocalPage:false}
            ]"
            month = "June"
            year = "2019"
        />
        <ProjectCard 
            img = "thumbnails/career.gif"
            title = "Natural Language Processing"
            subTitle = "Deciding my career path using NLP"
            description = "
                Suitable career path for the fictional character Tintin was found using NLP techniques. 
                The program was then used on myself to determine suitable career path.
            "
            programmingLanguage = "Python"
            :technologies = "['NLTK', 'GloVe', 'Word2vec']"
            :buttons = "[{'text':'Visit Page', 'link':'career', isLocalPage:true}]"
            month = "June"
            year = "2019"
        />
        <ProjectCard 
            img = "thumbnails/genetic.gif"
            title = "Genetic Algorithm"
            subTitle = "Controlling particle with charge using genetic algorithm"
            description = "
                A particle with charge can be accelerated by varying the electric field. 
                The genetic algorithm learns to control the particle along a path by using this phenomenon.
            "
            programmingLanguage = "Python"
            :technologies = "['Matplotlib', 'numpy']"
            :buttons = "[{'text':'Visit Page', 'link':'genetics', isLocalPage:true}, 
            {'text':'git', 'link':'https://github.com/TJ-coding/controlling-particle-with-genetic-algorithm', isLocalPage:false}]"
            month = "December" 
            year = "2018"
        />

        <ProjectCard 
            img = "thumbnails/yolo.gif"
            title = "Image Detection and Annotation"
            subTitle = "Real time face detection and masking using YOLO"
            description = "
                You Only Look Once model was trained on the images to detect faces. 
                The trained model was used to detect and mask a face in real time.
            "
            programmingLanguage = "Python"
            :technologies = "['OpenCV', 'YOLO', 'xml']"
            :buttons = "[{'text':'Visit Page', 'link':'yolo', isLocalPage:true}, 
            {'text':'git', 'link':'https://github.com/TJ-coding/yoloAnnotator', isLocalPage:false}]"
            month = "August"
            year = "2018"
        />

        <ProjectCard 
            img = "thumbnails/chaos.gif"
            title = "Chaos"
            subTitle = "Helping team by visualising lorenz attractor"
            description = "
                I supported a team by writing a program that visualises the Lorenz attractor. 
                The team used the program to confirm their findings visually.
            "
            programmingLanguage = "Python"
            :technologies = "['Matplotlib', 'plotly', 'numpy']"
            :buttons = "[{'text':'Visit Page', 'link':'chaos', isLocalPage:true }, 
            {'text':'git', 'link':'https://github.com/TJ-coding/lorenz_attractor', isLocalPage:false}]"
            month = "March"
            year = "2018"
        />
    </div>
</template>

<script>
import ProjectCard from './ProjectCard.vue'

export default {
    components:{
        ProjectCard
    }
}
</script>


<style scoped>
.card-album{
    padding-top: 1rem;
    width: auto;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(10rem,25rem));
    grid-auto-rows: 1fr;
    grid-gap: 3rem;
    justify-content: center;
}
</style>